<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21 2H3a1 1 0 00-1 1v18a1 1 0 002 0v-3h7.5v3.5a.5.5 0 001 0V9h3.25v1.07a2.11 2.11 0 00-1.46 1.24.5.5 0 10.92.38 1.13 1.13 0 012.08 0 .5.5 0 00.46.31.43.43 0 00.19 0 .49.49 0 00.27-.65 2.11 2.11 0 00-1.46-1.24V9H20v12a1 1 0 002 0V3a1 1 0 00-1-1zm-9.5 2v4H4V4zM4 17v-3h7.5v3zm7.5-4H4V9h7.5zm1-5V4H20v4z"/><path d="M8.5 15H7a.5.5 0 000 1h1.5a.5.5 0 000-1z"/></svg>